module.exports = __webpack_public_path__ + "static/media/conflictCard.15a21a77.svg";